function r(...i) {
  const e = i.filter(Boolean).join(" ");
  return e.length > 0 ? e : void 0;
}
export {
  r as g
};
//# sourceMappingURL=get-aria-describedby-G1wcWKF2.mjs.map
